import { ALL_LOCAL_STORAGE_USER_RELATED_KEYS } from "../axios/constants";

export const set = (key, data) =>
    localStorage.setItem(key, JSON.stringify(data));
export const get = (key) =>
    JSON.parse(localStorage.getItem(key));

export const clear = (key) =>
    localStorage.removeItem(key);
export const clearAll = () => {
    for (const key of ALL_LOCAL_STORAGE_USER_RELATED_KEYS) {
        clear(key);
    }
}